import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-pedido-drp-lucro-liquido-badge',
    templateUrl : 'pedido-drp-lucro-liquido-badge.component.html',
    styleUrls: ['./pedido-drp-lucro-liquido-badge.component.less']
})
export class PedidoDRPLucroLiquidoBadgeComponent {
    @Input() isShowLabel = false;
    @Input() isLoading = false;
    @Input() valorLucroLiquido: number;
    @Input() percLucroLiquido: number;
    @Input() percLucroLiquidoAbaixo: boolean;

    @Input() fontSize = '75%';
    @Input() padding = '0.4rem';
}
